window.addEventListener(
  "DOMContentLoaded",
  () => {
    const options = {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    };
    const options2 = {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: ".swiper-pagination-usage-guide",
        clickable: true,
      },
    };

    let swipersItems = [];
    swipersItems[0] = new Swiper("#swiper01", options);
    swipersItems[1] = new Swiper("#swiper02", options2);
    swipersItems[2] = new Swiper("#swiper03", {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: true,
      centeredSlides: true,
      navigation: {
        nextEl: ".custom-swiper-button-next",
        prevEl: ".custom-swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
          centeredSlides: true,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 26,
          centeredSlides: false,
        },
      },
    });
  },
  false
);
